exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-cards-due-section__dueDateSection__37Ql8 {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 0 16px 0 8px;\n}\n.team-cards-due-section__dueDateCard__12R7F {\n  padding-bottom: 16px;\n  padding-left: 8px;\n}\n.team-cards-due-section__dueList__2MnTD {\n  margin: -8px 0 16px 0;\n}\n.team-cards-due-section__scrollNavContainer__1iDzf {\n  flex: 0 0 auto;\n  padding-top: 40px;\n  width: 260px;\n}\n.team-cards-due-section__dueDateLists__3Kjkq {\n  flex: 0 0 auto;\n  width: 436px;\n}\n", ""]);

// exports
exports.locals = {
	"dueDateSection": "team-cards-due-section__dueDateSection__37Ql8",
	"dueDateCard": "team-cards-due-section__dueDateCard__12R7F",
	"dueList": "team-cards-due-section__dueList__2MnTD",
	"scrollNavContainer": "team-cards-due-section__scrollNavContainer__1iDzf",
	"dueDateLists": "team-cards-due-section__dueDateLists__3Kjkq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2133/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/team-cards-due-section.less
// module id = jQXe
// module chunks = 1